import { ApiError } from "@vana/core";

export class ListReportsError extends ApiError {}

export class ResolveReportError extends ApiError {}
